export const CLIENT_APPROVAL_FLOWS = Object.freeze({
  CURRENT: "current",
  ORDER_FIRST: "order_first",
});

export const normalizeClientApprovalFlow = (value) =>
  value === CLIENT_APPROVAL_FLOWS.ORDER_FIRST
    ? CLIENT_APPROVAL_FLOWS.ORDER_FIRST
    : CLIENT_APPROVAL_FLOWS.CURRENT;

export const buildClientApprovalJourney = ({
  flow,
  hasProof = false,
  requiresPayment = false,
  paymentDueOnSign = true,
  paymentLabel = "Pay deposit",
} = {}) => {
  const normalizedFlow = normalizeClientApprovalFlow(flow);
  const salesOrderStep = {
    key: "sales-order",
    label: "Approve or request changes",
    description: "Review the Sales Order details and colour breakdown.",
  };
  const proofStep = {
    key: "proof",
    label: "Approve artwork proof",
    description: "Review and approve the artwork proof when applicable.",
  };
  const paymentStep = {
    key: "payment",
    label: paymentLabel,
    description: String(paymentLabel || "").toLowerCase().includes("deposit")
      ? "Deposit payment is the final step."
      : "Payment is the final step.",
  };

  if (normalizedFlow === CLIENT_APPROVAL_FLOWS.ORDER_FIRST) {
    return [
      salesOrderStep,
      ...(hasProof ? [proofStep] : []),
      ...(requiresPayment ? [paymentStep] : []),
    ];
  }

  return [
    ...(hasProof ? [proofStep] : []),
    ...(requiresPayment && paymentDueOnSign ? [paymentStep] : []),
    salesOrderStep,
    ...(requiresPayment && !paymentDueOnSign ? [paymentStep] : []),
  ];
};

export const labelClientApprovalJourneyParts = (steps = []) =>
  (steps || []).map((step, index, list) => ({
    ...step,
    partNumber: list.length > 1 ? index + 1 : null,
    partCount: list.length,
  }));
